import * as fromDatatype from '../datatype-library/index';

export class app_psnl_menu_template_sharing_by_tenant_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  menu_template_hdr_guid: fromDatatype.GuidDataFieldInterface;
  tenant_hdr_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_by_name: fromDatatype.VarcharDatatypeInterface;
  updated_by_name: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  property_json: any;
  acl_config: any;
  acl_policy: any;
}

export class app_psnl_menu_template_sharing_by_tenant_link_RowClass implements app_psnl_menu_template_sharing_by_tenant_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  menu_template_hdr_guid: fromDatatype.GuidDataFieldInterface;
  tenant_hdr_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_by_name: fromDatatype.VarcharDatatypeInterface;
  updated_by_name: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  property_json: any;
  acl_config: any;
  acl_policy: any;
}